import * as Styled from './ImpactText.styled';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The Heading and Description for the Impact Block
 */
export const ImpactText = ({
  headingContent,
  descriptionContent,
  cssColor,
  cssTextAlign
}) => /*#__PURE__*/_jsxs(Styled.ImpactTextContainer, {
  cssColor: cssColor,
  cssTextAlign: cssTextAlign,
  children: [/*#__PURE__*/_jsx(Styled.ImpactHeading, {
    children: headingContent
  }), /*#__PURE__*/_jsx(Styled.ImpactDescription, {
    children: descriptionContent
  })]
});